import { createSelector } from '@reduxjs/toolkit'
import { RootState } from '../../../../store/types'

export const accountsBankingProductLoanReceiptsFiltersSelector = (id: string) =>
  createSelector(
    [(state: RootState) => state.accounts.master.filters.bankingProduct.loanReceipts],
    (filters) => filters[id] ?? {},
  )
